module.exports = __webpack_public_path__ + "static/media/logo.86df4091.svg";